import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FormService } from 'app/services/form.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-pro-drug-precursor',
  templateUrl: './pro-drug-precursor.component.html',
  styleUrls: ['./pro-drug-precursor.component.scss']
})
export class ProDrugPrecursorComponent implements OnInit, OnDestroy {
  drugPrecursor!: string;
  private sizeChangeSubscription!: Subscription;
  private mobileDeviceSize: boolean = false;


  constructor(private responsive: BreakpointObserver, private formService: FormService) { }

  ngOnInit(): void {
    this.drugPrecursor = this.currentForm.get('isProDrug')?.value;

    this.sizeChangeSubscription = this.responsive.observe([Breakpoints.Handset]).subscribe(result => {
      if (result.matches) {
        this.mobileDeviceSize = true;
      } else {
        this.mobileDeviceSize = false;
      }
    });

  }

  ngOnDestroy(): void {
    this.sizeChangeSubscription.unsubscribe();
  }


  updateValue(value: string) { 
    if(!value) {
      return;
    }

    this.drugPrecursor = value;
    if(!this.drugPrecursor || (this.drugPrecursor !== 'Yes' && this.drugPrecursor !== 'No')) {
      return;
    }
    
    this.formService.updateUsanFormValue('isProDrug', this.drugPrecursor);
  }

  get isMobileDeviceSize(): boolean {
    return this.mobileDeviceSize;
  }

  get currentForm(): FormGroup {
    return this.formService.getCurrentUsanFormValue();
  }

  public isDrugPrecursorCheck(value: string): boolean {
    if(this.drugPrecursor) {
      return this.drugPrecursor == value;
    }

    return false;
  }

  get drugPrecursorValue() {
    return this.currentForm.get('isProDrug')?.value;
  }
  

  compareFn(value: string): boolean {
    return value == this.drugPrecursorValue;
  }
}
